import { API_BASE_URL2, API_URL, DEMO_MODE } from ".";
import {
  reservationResponse,
  scanIDBackDocument,
  scanIDDocument,
  scanIDBackDocumentChild,
  scanIDDocumentChild,
  scanPassportData,
  scanPassportData2,
  scanPassportData3,
  scanQRData,
} from "../constants/scanjsondata";
import moment from "moment";
import axios from "axios";
import { formatSysDate } from "../helpers/commonHelper";
import {
  AuditTrailLogRes,
  GenerateTokenRes,
  GenericSuccessRes,
  GetMaintenanceModeStatusRes,
  GetPropertyInfoRes,
  PostPaymentToPMSRes,
  SaveRegistrationCardRes,
  UpdatePMSTokenRes,
  UpdateStageFromKioskRes,
  VerifyQueueOrCheckinRes,
} from "../constants/demo/demo";
import { GetSettingParameterRes } from "../constants/demo/settings-parameter";
import { GetFieldListRes } from "../constants/demo/field-list";
import { GetStepWithModulesRes } from "../constants/demo/step-modules";
import { GetKioskConfigurationRes } from "../constants/demo/kiosk-configuration";
import { GetLanguageMasterRes } from "../constants/demo/language-master";
import { VerifyEarlyCheckInRes } from "../constants/demo/verify-early-checkin";
import { GetCurrentStepRes } from "../constants/demo/current-step";
import { GetAllReservationProfilesRes } from "../constants/demo/all-reservation-profiles";
import { GetReservationDetailsRes } from "../constants/demo/reservation-details";
import { GetDocumentMasterRes } from "../constants/demo/document-master";
import { GetAllUIConfigurationRes } from "../constants/demo/all-ui-configuration";
import { GetCountriesRes } from "../constants/demo/countries";
import { getReservationPaymentInfoRes } from "../constants/demo/reservation-payment-info";
import { GetAllPackagesRes } from "../constants/demo/all-packages";
import { AddPackageRes } from "../constants/demo/add-package";
import { GetUserConsentMasterRes } from "../constants/demo/user-consent-master";
import { GetTermsAndConditionRes } from "../constants/demo/terms-and-confition";
import { GetauthorizationHistoryRes } from "../constants/demo/authorization-history";
import { GetAcceptedCardsRes } from "../constants/demo/accepted-card";
import { SaleRes } from "../constants/demo/sale";
import { UpdateUserProfileRes } from "../constants/demo/update-user-profile";
import { GetMembershipCodeMasterRes } from "../constants/demo/membership-code-master";
import { FetchFolioRes } from "../constants/demo/fetch-folio";
import { getScanDataFromWebhostQRRes } from "../constants/demo/scan-qr";
import { GetStatesRes } from "../constants/demo/state";

//axios header setup
// const API_URL = process.env.REACT_APP_API_BASE_URL;
// const API_BASE_URL2 = process.env.REACT_APP_API_BASE_URL2;

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common["Accept"] = "application/json, text/plain, */*";

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

const axios2 = axios.create({
  // baseURL: API_BASE_URL2,
  // headers: {
  //   common: {
  //     "Accept": "application/json, text/plain, */*",
  //     "Access-Control-Allow-Origin": "*",
  //     "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  //   },
  //   post: {
  //     "Content-Type": "application/json",
  //   },
  // },
  baseURL: API_BASE_URL2,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
});

//get accepted cards to show in payment modal
export const getAcceptedCards = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("GetAcceptedCards DEMO");
    return { data: GetAcceptedCardsRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/Payment/GetAcceptedCards`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// auth api
export const loginApi = (data) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("loginApi DEMO");
    return { data: GenerateTokenRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/Authentication/GenerateToken", data);
};

// Generate Token api
export const generateTokenApi = (data) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("generateTokenApi DEMO");
    return { data: GenerateTokenRes, status: 200, statusText: "OK" };
  }
  var hey = axios.post("api/Authentication/GenerateToken", data);
  return hey;
};

export const makePayment = (data) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("makePayment DEMO");
    return { data: SaleRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/PosPayment/Sale", data);
};

//***************************For Scanning******************************* */
export const sendFolioEmail = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("sendFolioEmail DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Email/FolioSend?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const sendCheckinMail = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("sendCheckinMail DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Email/SendCheckinMail?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const printCheckinSlip = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("printCheckinSlip DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  // debugger
  return axios.post(`api/Print/printCheckinSlip`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

//to initiate print
export const webHostPrintingCall = (data) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("webHostPrintingCall DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  return axios2.post(`print/PrintDocument`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

//get user details
export const getReservationDetails = async (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getReservationDetails DEMO");
    await sleep(1500);
    return { data: GetReservationDetailsRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/GetReservationDetails?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  //return { data: reservationResponse };
};

//get reservationAutherizationHistory details
export const GetauthorizationHistory = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("GetauthorizationHistory DEMO");
    return { data: GetauthorizationHistoryRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/GetauthorizationHistory?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  //return { data: reservationResponse };
};

//get membership description from db
export const GetMembershipCodeMaster = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("GetMembershipCodeMaster DEMO");
    return { data: GetMembershipCodeMasterRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  const query = searchParams.toString();
  return axios.get(`api/Kiosk/GetMembershipCodeMaster?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getReservationPaymentInfo = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getReservationPaymentInfo DEMO");
    return {data: getReservationPaymentInfoRes,status: 200,statusText: "OK"};
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/GetReservationPaymentInfo?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  //return { data: reservationResponse };
};

export const getKioskConfiguration = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getKioskConfiguration DEMO");
    return { data: GetKioskConfigurationRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/GetKioskConfiguration?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getKioskData = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getKioskData DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/Master/GetKioskMaster`, {
    //headers: { Authorization: `Bearer ${token}` },
  });
};

export const getMaintenanceModeStatus = async (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getMaintenanceModeStatus DEMO");
    return { data: GetMaintenanceModeStatusRes, status: 200, statusText: "OK" };
  }
  const response = await axios.get(`/api/Kiosk/GetMaintenanceModeStatus`);
  return response.data;
};
export const getKioskMaintenanceMode = async (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getKioskMaintenanceMode DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();

  //const response =  await axios.get(`/api/Kiosk/GetKioskMaintenanceMode`);

  //console.log("********************************************************getKioskMaintenanceMode*********response*****************",response);

  return axios.get(`api/Kiosk/GetKioskMaintenanceMode?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  //return response.data;
};
export const getFieldList = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getFieldList DEMO");
    return { data: GetFieldListRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/Master/GetFieldList`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getCountries = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getCountries DEMO");
    return { data: GetCountriesRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/Master/GetCountries`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getManualAuthentication = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getManualAuthentication DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/ManualAuthenticationAllowed?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  //return { data: { result: true } };
};

//GetAllProfile by ConfirmationNo
export const getAllProfile = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getAllProfile DEMO");
  }
  return axios.get(
    `api/Kiosk/GetAllProfiles?ConfirmationNo=${data?.replace(" ", "")}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};
export const getAllReservationProfile = (data, nameId, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getAllReservationProfile DEMO");
    return {
      data: GetAllReservationProfilesRes,
      status: 200,
      statusText: "OK",
    };
  }
  return axios.get(
    `api/Kiosk/GetAllReservationProfiles?ConfirmationNo=${data?.replace(
      " ",
      ""
    )}&ReservationNameID=${nameId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};
export const getAllReservationProfileForKeyPickup = (data, nameId, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getAllReservationProfileForKeyPickup DEMO");
  }
  return axios.get(
    `api/Kiosk/GetAllReservationProfilesForKeyPickUp?ConfirmationNo=${data?.replace(
      " ",
      ""
    )}&ReservationNameID=${nameId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};
export const checkReservationDB = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("checkReservationDB DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/Kiosk/CheckReservationDB", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//FetchFolio by ConfirmationNo
export const fetchFolio = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("fetchFolio DEMO");
    return {
      data: FetchFolioRes,
      status: 200,
      statusText: "OK",
    };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/FetchFolio?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//GetAvailableRooms
export const getAvailableRooms = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getAvailableRooms DEMO");
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/GetAvailableRooms?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//GetAllowedDocuments
export const getAllowedDocuments = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getAllowedDocuments DEMO");
    return { data: GetDocumentMasterRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();

  return axios.get(`api/Master/GetDocumentMaster?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Is early checkin
export const isEarlyCheckin = (token, confirmationNo, reservationNameId) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("isEarlyCheckin DEMO");
    return { data: VerifyEarlyCheckInRes, status: 200, statusText: "OK" };
  }
  // const searchParams = new URLSearchParams(data);
  // let query = searchParams.toString();
  return axios.get(
    `api/Kiosk/VerifyEarlyCheckIn?ConfirmationNo=${confirmationNo}&ReservationNameId=${reservationNameId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

// navigation get current step
export const currentStep = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("currentStep DEMO");
    return { data: GetCurrentStepRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Master/GetCurrentStep?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// navigation url/ stage api
export const navigationPath = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("navigationPath DEMO");
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/GetNavigationStep?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Get terms and conditions data
export const getTermsAndConditons = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getTermsAndConditons DEMO");
    return { data: GetTermsAndConditionRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/Reservation/GetTermsAndCondition`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getPropertyData = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getPropertyData DEMO");
    return { data: GetPropertyInfoRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/Master/GetPropertyInfo`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const verifyQueueOrCheckin = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getPropertyData DEMO");
    return { data: VerifyQueueOrCheckinRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/VerifyQueueOrCheckin?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//get user docuemnts for qr code
export const fetchProfileDocuments = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("fetchProfileDocuments DEMO");
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/GetAllProfileDocuments?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// ******************** Post APIS ************************//

// AssignRoom
export const assignRoom = (data, token, query) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("assignRoom DEMO");
  }
  const searchParams = new URLSearchParams(query);
  let property = searchParams.toString();
  return axios.post(`api/Kiosk/AssignRoom?${property}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//Add Package
export const addPackage = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("addPackage DEMO");
    return { data: AddPackageRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/Kiosk/AddPackage", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Get Room status
export const getRoomStatus = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getRoomStatus DEMO");
  }
  return axios.post("api/Kiosk/GetRoomStatus", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//Room upsell
export const roomUpsell = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("roomUpsell DEMO");
  }
  return axios.post("api/Kiosk/RoomUpsell", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
// Queue Room
export const queueRoom = (data, token, query) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("queueRoom DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  return axios.post(`api/Reservation/QueueRoom`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
//update user Profile - reservation details page
export const updateUserProfile = (data, token, query) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("updateUserProfile DEMO", data);
    return { data: UpdateUserProfileRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(query);
  let property = searchParams.toString();
  return axios.post(`api/Kiosk/UpdateUserProfile?${property}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//update user Profile - reservation details page
export const updateSingleProfile = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("updateSingleProfile DEMO");
  }
  return axios.post("api/Kiosk/UpdateProfile", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//checkin - after payment call this api
export const checkIn = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("checkIn DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/Kiosk/CheckIn", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//checkout
export const checkOut = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("checkOut DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/Kiosk/CheckOut", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
const wait = (milliseconds) =>
  new Promise((res, rej) => setTimeout(milliseconds));
function getTodayAtMidnightFormatted() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00:00`;
}
//Encode key - create key page api call
export const encodeKey = async (data, token, keyVendor) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("encodeKey DEMO");
    await sleep(1000);
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  //  debugger
  if (keyVendor === "DORMAKABA-DISPENSER") {
    console.log("DORMAKABA-DISPENSER", data);
    var response = await cardPosition(data?.encoderPort);
    console.log("DORMAKABA-DISPENSER cardPosition", response);
    if (response?.status === 200) {
      wait(3000);
      // response = await cardAccept(data?.encoderPort);
      // wait(3000);

      // if (response?.status === 200) {
      //   wait(3000);

      const response3 = await saflokEncodekey(data);
      console.log("DORMAKABA-DISPENSER saflokEncodekey", response3);
      if (response3?.status === 200 && response3?.data?.result === true) {
        let response1 = await cardEject(data?.encoderPort);
        console.log("DORMAKABA-DISPENSER cardEject", response1);
        //#region commented the following due to card getting retracted during encoding
        //response1 = await cardDrop(data?.encoderPort);
        //response1 = await ledOn(data?.encoderPort);
        //response1 = await ledOff(data?.encoderPort);
        //#endregion
        return {
          data: {
            result: response3?.data?.result ?? true,
          },
          result: response3?.data?.result ?? true,
        };
      } else {
        //let response1 = await cardDrop(data?.encoderPort); TODO
        return {
          data: {
            result: false,
          },
          result: false,
        };
        // }
      }
    }
  } else if (keyVendor === "DORMAKABA") {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const formattedToday = getTodayAtMidnightFormatted();
    console.log("Today :", formattedToday); // e.g. "2025-06-19T00:00:00"
    console.log("Reservation ArrivalDate :", data?.arrivalDate); //
    const reservationArrivalDate = new Date(data?.arrivalDate);
    reservationArrivalDate.setHours(0, 0, 0, 0);

    // Clone original data
    const dormakabaData = { ...data };
    //debugger
    if (reservationArrivalDate.getTime() !== today.getTime()) {
      console.log("reservation ArrivalDate different from current date");
      // console.log("setting arrivalDate to ",formattedToday);
      console.log("updating checkinDateTime to ", formattedToday);
      //  dormakabaData.arrivalDate = formattedToday;
      dormakabaData.checkinDateTime = formattedToday; // ✅ "YYYY-MM-DDT00:00:00"
    }
    //debugger
    const response = await saflokEncodekey(dormakabaData);

    if (response?.status === 200) {
      return {
        data: {
          result: response?.data?.result ?? true,
        },
        result: response?.data?.result ?? true,
      };
    }
  } else if (keyVendor === "MIWA") {
    const response = await miwaEncodekey(data);

    console.log("KEY##" + JSON.stringify(response));

    if (response?.status === 200) {
      return {
        data: {
          result:
            response?.data?.Result ??
            response?.result ??
            response?.Result ??
            false,
        },
        result:
          response?.data?.Result ??
          response?.result ??
          response?.Result ??
          false,
      };
    } else {
      return {
        data: {
          result: false,
        },
        result: false,
      };
    }
  } else {
    return axios.post("api/Kiosk/EncodeKey", data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

// Save reg card  - (signature pad api call)
export const saveRegistrationCard = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("saveRegistrationCard DEMO:", data);
    return { data: SaveRegistrationCardRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/Reservation/SaveRegistrationCard", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Save folio card  - (signature pad api call)
export const saveFolio = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("saveFolio DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/Reservation/SaveFolio", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//trigger payment
export const triggerPayment = async (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("triggerPayment DEMO");
    await sleep(1500);
    return { data: SaleRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/PosPayment/Sale", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//payemnt update to PMS
export const postPaymentToPMS = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("postPaymentToPMS DEMO");
    return { data: PostPaymentToPMSRes, status: 200, statusText: "OK" };
  }
  return axios.post("api/Kiosk/PostPaymentToPMS", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updatePMSToken = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("updatePMSToken DEMO");
    return { data: UpdatePMSTokenRes, status: 200, statusText: "OK" };
  }
  return axios.post(`api/Reservation/UpdatePMSToken?`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getStepWithModules = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getStepWithModules DEMO");
    return { data: GetStepWithModulesRes, status: 200, statusText: "OK" };
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();

  return axios.get(`api/Master/GetStepWithModules?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getSettingList = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getSettingList DEMO");
    return { data: GetSettingParameterRes, status: 200, statusText: "OK" };
  }
  const header = {
    Authorization: `Bearer ${token}`,
  };
  return axios.get("api/Reservation/GetSettingParameter", { headers: header });
};

export const getUIConfigurations = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getUIConfigurations DEMO");
    return { data: GetAllUIConfigurationRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/UIConfig/GetAllUIConfiguration`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getAllUpsellPackages = async (
  token,
  ConfirmNo,
  ReservationNameID
) => {
  try {
    if (DEMO_MODE) {
    sleep(500);
      console.log("getAllUpsellPackages DEMO");
      return { data: GetAllPackagesRes, status: 200, statusText: "OK" };
    }
    return axios.get(
      `api/Upsell/GetAllPackages?ConfirmationNo=${ConfirmNo}&ReservationNameID=${ReservationNameID}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  } catch (error) {
    console.error("Error verifying face:", error);
    throw error;
  }
};

export const GetPackagesMaster = async (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("GetPackagesMaster DEMO");
  }
  try {
    return axios.get(`api/Upsell/GetPackagesMaster`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.error("GetPackagesMaster:", error);
    throw error;
  }
};

//getReservationTypes
export const getReservationTypes = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getReservationTypes DEMO");
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Master/getReservationTypes?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//getSettingParameter
export const getSettingParameter = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getSettingParameter DEMO");
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Reservation/getSettingParameter?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//get UserConsent Master
export const getUserConsentMaster = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getUserConsentMaster DEMO");
    return { data: GetUserConsentMasterRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/Kiosk/getUserConsentMaster`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getState = (token, countryCode) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("GetStates DEMO");
    return { data: GetStatesRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/Master/GetStates?CountryCode=` + countryCode, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getActivePreAuth = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getActivePreAuth DEMO");
  }
  return axios.get(`api/Payment/getActivePreAuth`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchLanguage = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("fetchLanguage DEMO");
  }
  return axios.get(`api/Payment/fetchLanguage`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateAdultCount = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("updateAdultCount DEMO");
  }
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/Kiosk/ModifyReservationBooking`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const UpdateChildCountToDB = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("UpdateChildCountToDB DEMO");
  }
  return axios.post(`api/Kiosk/UpdateChildCountToDB`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // optional but good practice
    },
  });
};

//#region Activation
export const getNonRegisteredKiosks = () => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getNonRegisteredKiosks DEMO");
  }
  return axios.get(`api/Kiosk/GetNonRegisteredKiosks`);
};

export const verifyActivation = (propertyCode, kioskID) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("verifyActivation DEMO");
  }
  return axios.get(
    `api/Kiosk/VerifyActivation?propertyCode=` +
      propertyCode +
      `&kioskID=` +
      kioskID
  );
};

export const registerDevice = (data) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("registerDevice DEMO");
  }
  return axios.post("api/Kiosk/RegisterDevice", data);
};

//#endregion

//#region Webhost

// get clear scan/qr data
export const clearScanData = () => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("clearScanData DEMO");
  }
  return axios2.get(`scanner/ClearResults`, { timeout: 30000 });
  //return { data: true };
};

// get scan/qr data

export const getScanDataFromWebhost = (guestCount) => {
  // if (guestCount == 1) return { data: scanPassportData2 };
  //return { data: scanPassportData2 };
  // if (guestCount == 2) return { data: scanPassportData3 };
  // //return { data: scanPassportData };
  // //else
  // if (guestCount == 0)
  //   return { data:scanIDDocument };
  // if (guestCount == 1)
  //   return { data:scanIDDocumentChild };
  try {
    var promise = axios2
      .get(`scanner/scan?isflip=false`)
      .catch((error) => console.log(error));
    if (DEMO_MODE) {
    sleep(500);
      console.log("= DEMO");
      var wait = async () => {
        await promise;
      };
      wait();
      return { data: scanPassportData };
    }
    return promise;
  } catch (error) {
    if (DEMO_MODE) {
    sleep(500);
      return { data: scanPassportData };
    }
    console.log(error);
    return { data: { result: false }, status: 500 };
  }
};

export const getScanDataFromWebhostBack = (guestCount) => {
  // if (guestCount == 1) return { data: scanPassportData2 };
  // if (guestCount == 2) return { data: scanPassportData3 };

  // if (guestCount == 0)
  //   return { data:scanIDBackDocument};
  // if (guestCount == 1)
  //   return { data:scanIDBackDocumentChild };
  try {
    var promise = axios2
      .get(`scanner/scan?isflip=true`)
      .catch((error) => console.log(error));
    if (DEMO_MODE) {
    sleep(500);
      console.log("= DEMO");
      var wait = async () => {
        await promise;
      };
      wait();
      return { data: scanPassportData2 };
    }
    return promise;
  } catch (error) {
    if (DEMO_MODE) {
    sleep(500);
      return { data: scanPassportData2 };
    }
    console.log(error);
    return { data: { result: false }, status: 500 };
  }
};

export const getScanDataFromWebhostQR = () => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getScanDataFromWebhostQR DEMO");
    return getScanDataFromWebhostQRRes;
  }
  return axios2.get(`scanner/scan`);
  //return { data: scanQRData };
};

// get start face verification scan/qr data
export const faceVerification = () => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("faceVerification DEMO");
  }
  return axios2.get(`scanner/StartFaceVerification`);
};

//#region Dormakaba
export const cardPosition = (port) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("cardPosition DEMO");
  }
  return axios2.get(`Key/CardPosition?Port=` + port);
};

export const cardAccept = (port) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("cardAccept DEMO");
  }
  return axios2.get(`Key/CardAccept?Port=` + port);
};

export const cardEject = (port) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("cardEject DEMO");
  }
  return axios2.get(`Key/CardEject?Port=` + port);
};

export const cardDrop = (port) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("cardDrop DEMO");
  }
  return axios2.get(`Key/CardDrop?Port=` + port);
};

export const ledOn = (port) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("ledOn DEMO");
  }
  return axios2.get(`Key/DeviceLedOn?Port=` + port);
};

export const ledOff = (port) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("ledOff DEMO");
  }
  return axios2.get(`Key/DeviceLedOff?Port=` + port);
};
export const saflokEncodekey = (data) => {
  //debugger
  if (DEMO_MODE) {
    sleep(500);
    console.log("  if DEMO");
  }
  data.confirmationNo = data.confirmationNo?.replace("-", "");
  data.reservationNo = data.reservationNo?.replace("-", "");

  // let today = new Date();
  // data.roomNumber = "205";
  // data.checkinDateTime = formatSysDate(today);
  // data.arrivalDate = formatSysDate(today);

  // var date = new Date();
  // // add a day
  // date.setDate(date.getDate() + 1);
  // data.checkoutDateTime = formatSysDate(date);
  // data.departureDate = formatSysDate(date);

  const basicAuth = encodeBasicAuth(
    data.encoderUsername ?? "DummyUser",
    data.encoderPassword ?? "DummyPwd"
  );

  return axios2.post(`saflok/encodekey`, data, {
    headers: { Authorization: `Basic ${basicAuth}` },
  });
};
export const postFaceLiveliness = (data) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("postFaceLiveliness DEMO");
  }
  return axios2.post(`Liveness/FaceLiveness`, data);
};
//#endregion
// Get language master
export const getLanguageMaster = (token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getLanguageMaster DEMO");
    return { data: GetLanguageMasterRes, status: 200, statusText: "OK" };
  }
  return axios.get(`api/Reservation/GetLanguageMaster`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const pushAuditLog = (token, data) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("pushAuditLog DEMO");
    return { data: AuditTrailLogRes, status: 200, statusText: "OK" };
  }
  return axios.post(`api/Kiosk/AuditTrailLog`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const pushStageDetails = (token, data) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("pushStageDetails DEMO");
    return { data: UpdateStageFromKioskRes, status: 200, statusText: "OK" };
  }
  return axios.post(`api/Kiosk/UpdateStageFromKiosk`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
const encodeBasicAuth = (username, password) => {
  return btoa(`${username}:${password}`);
};

export const getPostalCodeDetail = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("getPostalCodeDetail DEMO");
  }
  console.log("Inside getPostalCodeDetail:", data);
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/kiosk/GetPostalDetails?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// export const GetSignedFolioDocuments = (data, token) => {
//   debugger;
//   const searchParams = new URLSearchParams(data);
//   let query = searchParams.toString();
//   return axios.get(`api/kiosk/GetSignedDocuments?${query}`, {
//     headers: { Authorization: `Bearer ${token}` },
//   });
// };
export const GetSignedFolioDocuments = (data, token) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("GetSignedFolioDocuments DEMO");
    return { data: GenericSuccessRes, status: 200, statusText: "OK" };
  }
  //debugger;
  const searchParams = new URLSearchParams(data);
  let query = searchParams.toString();
  return axios.get(`api/kiosk/GetSignedDocumentImages?${query}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
//#region MIWA
export const miwaEncodekey = (data) => {
  if (DEMO_MODE) {
    sleep(500);
    console.log("miwaEncodekey DEMO");
  }
  // data.confirmationNo = data.confirmationNo?.replace("-", "");
  // data.reservationNo = data.reservationNo?.replace("-", "");

  // const date = new Date();
  // const formattedDate = moment(date).format('YYYY-MM-DD HH:mm:ss');
  // data.confirmationNo = formattedDate?.replace("-", "")?.replace(":", "")?.replace(" ", "");
  // data.reservationNo = formattedDate?.replace("-", "")?.replace(":", "")?.replace(" ", "");

  const date = new Date();
  const formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");

  const cleanedDate = formattedDate.replace(/[-:\s]/g, "");

  data.confirmationNo = cleanedDate;
  data.reservationNo = cleanedDate;

  return axios2.post(`miwa/encodekey`, data);
};

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

//#endregion
//#endregion
